"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = require("prop-types");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Tooltip = function Tooltip(_ref) {
  var className = _ref.className,
      toggleIcon = _ref.toggleIcon,
      children = _ref.children,
      onClick = _ref.onClick,
      direction = _ref.direction,
      text = _ref.text,
      passedIsActive = _ref.isActive,
      passedSetIsActive = _ref.setIsActive,
      otherProps = _objectWithoutProperties(_ref, ["className", "toggleIcon", "children", "onClick", "direction", "text", "isActive", "setIsActive"]);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isActive = _useState2[0],
      setIsActive = _useState2[1];

  return /*#__PURE__*/_react.default.createElement(TooltipWrapper, _extends({
    onMouseLeave: function onMouseLeave() {
      return passedSetIsActive && passedSetIsActive(false) || setIsActive(false);
    },
    className: className,
    onClick: onClick
  }, otherProps), /*#__PURE__*/_react.default.createElement(TooltipToggle, {
    onMouseMove: function onMouseMove() {
      return passedSetIsActive && passedSetIsActive(true) || setIsActive(true);
    },
    isActive: passedIsActive != null && passedIsActive || isActive
  }, toggleIcon), text && /*#__PURE__*/_react.default.createElement(TooltipText, {
    onMouseMove: function onMouseMove() {
      return passedSetIsActive && passedSetIsActive(true) || setIsActive(true);
    },
    isActive: passedIsActive != null && passedIsActive || isActive
  }, text), /*#__PURE__*/_react.default.createElement(TooltipContent, {
    active: passedIsActive != null && passedIsActive || isActive,
    direction: direction
  }, children));
};

var TooltipText = _styledComponents.default.p.withConfig({
  displayName: "TooltipText"
})(["margin-left:1rem;font-family:", ";font-size:14px;transition:color 0.2s ease;color:", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.font;
}, function (_ref3) {
  var isActive = _ref3.isActive,
      theme = _ref3.theme;
  return isActive ? theme.brand.primary : '#8990a3';
});

var TooltipWrapper = _styledComponents.default.div.withConfig({
  displayName: "TooltipWrapper"
})(["display:flex;align-items:center;-webkit-box-pack:center;justify-content:center;position:relative;cursor:pointer;outline:none;appearance:none;"]);

var TooltipToggle = _styledComponents.default.a.withConfig({
  displayName: "TooltipToggle"
})(["display:flex;z-index:10;width:2rem;height:2rem;border-radius:9999px;border:1.5px solid #8990a3;justify-content:center;align-items:center;font-family:", ";font-size:1.2rem;line-height:120%;color:#8990a3;transition:color 0.2s ease;", ""], function (_ref4) {
  var theme = _ref4.theme;
  return theme.font;
}, function (_ref5) {
  var isActive = _ref5.isActive;
  return isActive && (0, _styledComponents.css)(["color:", ";border:1.5px solid ", ";"], function (_ref6) {
    var theme = _ref6.theme;
    return theme.brand.primary;
  }, function (_ref7) {
    var theme = _ref7.theme;
    return theme.brand.primary;
  });
});

var TooltipContent = _styledComponents.default.div.withConfig({
  displayName: "TooltipContent"
})(["visibility:", ";z-index:9;position:absolute;opacity:", ";margin-bottom:1em;padding:1em;background-color:#11141c;width:600px;border-radius:5px;transform:", ";font-family:", ";transition:all 0.2s ease;font-size:14px;line-height:120%;color:white;", " &::before{content:'';position:absolute;left:", ";width:0;height:0;border:0.5em solid transparent;border-top-color:#11141c;-webkit-transform:translate(-50%,0);transform:translate(-50%,0);", "}"], function (_ref8) {
  var active = _ref8.active;
  return active ? 'visible' : 'hidden';
}, function (_ref9) {
  var active = _ref9.active;
  return active ? '1' : '0';
}, function (_ref10) {
  var active = _ref10.active;
  return active ? 'translate(-50%, 0)' : 'translate(-50%, 1em)';
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.font;
}, function (_ref12) {
  var direction = _ref12.direction;

  switch (direction) {
    case 'bottom':
      return (0, _styledComponents.css)(["top:150%;left:50%;"]);

    case 'bottomleft':
      return (0, _styledComponents.css)(["top:150%;left:-1300%;"]);

    case 'bottomright':
      return (0, _styledComponents.css)(["top:150%;left:1400%;"]);

    case 'left':
      return (0, _styledComponents.css)(["bottom:100%;left:-1300%;"]);

    case 'right':
      return (0, _styledComponents.css)(["bottom:100%;left:1400%;"]);

    default:
      return (0, _styledComponents.css)(["bottom:100%;left:50%;"]);
  }
}, function (_ref13) {
  var direction = _ref13.direction;
  return direction === 'left' ? '95%' : direction === 'right' ? '5%' : '50%';
}, function (_ref14) {
  var direction = _ref14.direction;

  switch (direction) {
    case 'bottom':
      return (0, _styledComponents.css)(["-webkit-transform:translate(50%,0);transform:rotate(180deg) translate(50%,0);bottom:100%;"]);

    case 'bottomleft':
      return (0, _styledComponents.css)(["-webkit-transform:translate(50%,0);transform:rotate(180deg) translate(50%,0);bottom:100%;left:95%;"]);

    case 'bottomright':
      return (0, _styledComponents.css)(["-webkit-transform:translate(50%,0);transform:rotate(180deg) translate(50%,0);bottom:100%;left:5%;"]);

    case 'left':
      return (0, _styledComponents.css)(["top:100%;left:95%;"]);

    case 'right':
      return (0, _styledComponents.css)(["top:100%;left:5%;"]);

    default:
      return (0, _styledComponents.css)(["top:100%;left:50%;"]);
  }
});

Tooltip.defaultProps = {
  toggleIcon: '?',
  children: 'Please provide text to be shown inside the tooltip.'
};
Tooltip.propTypes = {
  /** Extra class to be passed to the component. */
  className: _propTypes.string,

  /** Icon to be shown inside the toggle. (String) */
  toggleIcon: _propTypes.string.isRequired,

  /** Content to be shown inside the toggle.  */
  children: _propTypes.node.isRequired,

  /** Optional onClick function to be passed. */
  onClick: _propTypes.func,

  /** What direction the tooltop should pop out to */
  direction: _propTypes.string,

  /** Extra props to be passed to the component. */
  otherProps: _propTypes.object,

  /** Text for the tooltip */
  text: _propTypes.string,

  /** Manually pass the isActive state for showing the tooltip */
  isActive: _propTypes.bool,

  /** Manually set the isActive state for showing the tooltip */
  setIsActive: _propTypes.func
};
var _default = Tooltip;
exports.default = _default;